import { ListItemIcon } from "@material-ui/core";
import React from "react";
import { NavIconProps } from "./NavIconProps";

export default function NavbarIcon(props: NavIconProps) {
    return (
        <ListItemIcon className={props.navbarIconStyles}>
            {props.navbarIcon}
        </ListItemIcon>
    );
}
